module.exports = __webpack_public_path__ + "static/media/success.8cddce42.svg";